module.exports = __webpack_public_path__ + "img/5.ce162c1.jpg";